import { render, staticRenderFns } from "./JudgmentKeyValue.vue?vue&type=template&id=242f8dd4&scoped=true"
import script from "./JudgmentKeyValue.vue?vue&type=script&lang=js"
export * from "./JudgmentKeyValue.vue?vue&type=script&lang=js"
import style0 from "./JudgmentKeyValue.vue?vue&type=style&index=0&id=242f8dd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f8dd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow})
